const TextInput = ({  placeholder, name, value, onChange, type = "text", disabled = false, className }) => (
  <div className="flex max-w-[480px] flex-wrap items-end  py-3">
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        className={`p-2 outline-none ${className || ""}`} //
        // className="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-xl text-[#111518] focus:outline-0 focus:ring-0 border border-[#dce1e5] bg-white focus:border-[#dce1e5] h-14 placeholder:text-[#637988] p-[15px] text-base font-normal leading-normal"
      />
  </div>
);

export default TextInput;